import React from "react";
import type { ChatAttachmentType } from "src/components/ui/chat/useChatAttachments";

import { TipType } from "../types";
import EmptyStateChat from "./EmptyStateChat";

interface ChatAreaProps {
  messagesEndRef: React.RefObject<HTMLDivElement>;
  onSendMessage: (message: string, attachments?: ChatAttachmentType[]) => Promise<unknown> | unknown;
  userData: {
    pictureUrl?: string;
    firstName?: string;
    lastName?: string;
  };
  tips?: TipType[];
  isSendingMessage?: boolean;
  prefilledQuestion?: string;
}

// ChatArea is only used for empty state - it's a simple wrapper around EmptyStateChat
const ChatArea: React.FC<ChatAreaProps> = ({
  messagesEndRef,
  onSendMessage,
  tips = [],
  isSendingMessage = false,
  prefilledQuestion = "",
}) => {
  return <EmptyStateChat
    onSendMessage={onSendMessage}
    messagesEndRef={messagesEndRef}
    tips={tips}
    isSending={isSendingMessage}
    prefilledQuestion={prefilledQuestion}
  />;
};

export default ChatArea;
